/**
 * This is an auto generated file - do not modify manually!
 * Colors are fetched via Figma api
 */
var colors = {
  /**
   * Hyper Green '#93f2dc' 
   * @deprecated Use colors from the 2025 palette
   */
  hyperGreen: '#93f2dc',
  /**
   * Emerald Green '#1e4f45' 
   * @deprecated Use colors from the 2025 palette
   */
  emeraldGreen: '#1e4f45',
  /**
   * Electric Green '#78dec8' 
   * @deprecated Use colors from the 2025 palette
   */
  electricGreen: '#78dec8',
  /**
   * Vibrant Green '#4b9684' 
   * @deprecated Use colors from the 2025 palette
   */
  vibrantGreen: '#4b9684',
  /**
   * Forest Green '#377a6c' 
   * @deprecated Use colors from the 2025 palette
   */
  forestGreen: '#377a6c',
  /**
   * Energetic Red-Orange '#eb6437' 
   * @deprecated Use colors from the 2025 palette
   */
  energeticRedOrange: '#eb6437',
  /**
   * Haze Red-Orange '#bf4f2a' 
   * @deprecated Use colors from the 2025 palette
   */
  hazeRedOrange: '#bf4f2a',
  /**
   * Dusk Red-Orange '#9c4122' 
   * @deprecated Use colors from the 2025 palette
   */
  duskRedOrange: '#9c4122',
  /**
   * Fall Red-Orange '#ff9673' 
   * @deprecated Use colors from the 2025 palette
   */
  fallRedOrange: '#ff9673',
  /**
   * Aureolin Yellow '#f5e150' 
   * @deprecated Use colors from the 2025 palette
   */
  aureolinYellow: '#f5e150',
  /**
   * Citrine Yellow '#e5d240' 
   * @deprecated Use colors from the 2025 palette
   */
  citrineYellow: '#e5d240',
  /**
   * Old Yellow '#cfbd3a' 
   * @deprecated Use colors from the 2025 palette
   */
  oldYellow: '#cfbd3a',
  /**
   * Mini Yellow '#fff07a' 
   * @deprecated Use colors from the 2025 palette
   */
  miniYellow: '#fff07a',
  /**
   * Wild Green '#1bd99f' 
   * @deprecated Use colors from the 2025 palette
   */
  wildGreen: '#1bd99f',
  /**
   * Jungle Green '#15a87b' 
   * @deprecated Use colors from the 2025 palette
   */
  jungleGreen: '#15a87b',
  /**
   * Ocean Green '#0f7a5a' 
   * @deprecated Use colors from the 2025 palette
   */
  oceanGreen: '#0f7a5a',
  /**
   * Pine Green '#0a523c' 
   * @deprecated Use colors from the 2025 palette
   */
  pineGreen: '#0a523c',
  /**
   * Turquoise Green '#3ef0b9' 
   * @deprecated Use colors from the 2025 palette
   */
  turquoiseGreen: '#3ef0b9',
  /**
   * Powering Green '#18d270' 
   * @deprecated Use colors from the 2025 palette
   */
  poweringGreen: '#18d270',
  /**
   * Clover Green '#0fa355' 
   * @deprecated Use colors from the 2025 palette
   */
  cloverGreen: '#0fa355',
  /**
   * Oak Green '#0d753f' 
   * @deprecated Use colors from the 2025 palette
   */
  oakGreen: '#0d753f',
  /**
   * Mountain Green '#09522c' 
   * @deprecated Use colors from the 2025 palette
   */
  mountainGreen: '#09522c',
  /**
   * Spring Green '#1aeb7d' 
   * @deprecated Use colors from the 2025 palette
   */
  springGreen: '#1aeb7d',
  /**
   * Sunset Beige '#e3cca0' 
   * @deprecated Use colors from the 2025 palette
   */
  sunsetBeige: '#e3cca0',
  /**
   * Sand Beige '#baa783' 
   * @deprecated Use colors from the 2025 palette
   */
  sandBeige: '#baa783',
  /**
   * Brown Beige '#7d6e51' 
   * @deprecated Use colors from the 2025 palette
   */
  brownBeige: '#7d6e51',
  /**
   * Balancing Beige '#f3ead9' 
   * @deprecated Use colors from the 2025 palette
   */
  balancingBeige: '#f3ead9',
  /**
   * Energetic Orange '#ebae44' 
   * @deprecated Use colors from the 2025 palette
   */
  energeticOrange: '#ebae44',
  /**
   * Fine Orange '#d6921c' 
   * @deprecated Use colors from the 2025 palette
   */
  fineOrange: '#d6921c',
  /**
   * Golden Orange '#9e6c15' 
   * @deprecated Use colors from the 2025 palette
   */
  goldenOrange: '#9e6c15',
  /**
   * Stoical Orange '#ffc663' 
   * @deprecated Use colors from the 2025 palette
   */
  stoicalOrange: '#ffc663',
  /**
   * Orchid Purple '#d384d9' 
   * @deprecated Use colors from the 2025 palette
   */
  orchidPurple: '#d384d9',
  /**
   * Lavender Purple '#eeb6f2' 
   * @deprecated Use colors from the 2025 palette
   */
  lavenderPurple: '#eeb6f2',
  /**
   * Grape Purple '#934299' 
   * @deprecated Use colors from the 2025 palette
   */
  grapePurple: '#934299',
  /**
   * Plum Purple '#713475' 
   * @deprecated Use colors from the 2025 palette
   */
  plumPurple: '#713475',
  /**
   * Cushy Blue '#406aad' 
   * @deprecated Use colors from the 2025 palette
   */
  cushyBlue: '#406aad',
  /**
   * Composed Blue '#325285' 
   * @deprecated Use colors from the 2025 palette
   */
  composedBlue: '#325285',
  /**
   * Broad Blue '#23375b' 
   * @deprecated Use colors from the 2025 palette
   */
  broadBlue: '#23375b',
  /**
   * Blush Red '#f6bbc4' 
   * @deprecated Use colors from the 2025 palette
   */
  blushRed: '#f6bbc4',
  /**
   * Power Red '#d25564' 
   * @deprecated Use colors from the 2025 palette
   */
  powerRed: '#d25564',
  /**
   * Punch Red '#b83e4d' 
   * @deprecated Use colors from the 2025 palette
   */
  punchRed: '#b83e4d',
  /**
   * Ruby Red '#94323e' 
   * @deprecated Use colors from the 2025 palette
   */
  rubyRed: '#94323e',
  /**
   * Soft Red '#f08b9a' 
   * @deprecated Use colors from the 2025 palette
   */
  softRed: '#f08b9a',
  /**
   * Water Blue '#78a0d4' 
   * @deprecated Use colors from the 2025 palette
   */
  waterBlue: '#78a0d4',
  /**
   * Baby Blue '#c5d6ed' 
   * @deprecated Use colors from the 2025 palette
   */
  babyBlue: '#c5d6ed',
  /**
   * PowerRed-100 '#fde7e6' 
   */
  powerRed100: '#fde7e6',
  /**
   * PowerRed-200 '#fad1d1' 
   */
  powerRed200: '#fad1d1',
  /**
   * PowerRed-400 '#f59594' 
   */
  powerRed400: '#f59594',
  /**
   * PowerRed-500 '#ea6263' 
   */
  powerRed500: '#ea6263',
  /**
   * PowerRed-600 '#d62e40' 
   */
  powerRed600: '#d62e40',
  /**
   * PowerRed-700 '#b72434' 
   */
  powerRed700: '#b72434',
  /**
   * EnergeticOrange-100 '#ffedc6' 
   */
  energeticOrange100: '#ffedc6',
  /**
   * EnergeticOrange-200 '#ffd788' 
   */
  energeticOrange200: '#ffd788',
  /**
   * EnergeticOrange-400 '#f9a326' 
   */
  energeticOrange400: '#f9a326',
  /**
   * EnergeticOrange-500 '#db720a' 
   */
  energeticOrange500: '#db720a',
  /**
   * EnergeticOrange-600 '#be4f04' 
   */
  energeticOrange600: '#be4f04',
  /**
   * EnergeticOrange-700 '#ab3907' 
   */
  energeticOrange700: '#ab3907',
  /**
   * BalancingBeige-100 '#f3ead9' 
   */
  balancingBeige100: '#f3ead9',
  /**
   * BalancingBeige-200 '#e4d9c4' 
   */
  balancingBeige200: '#e4d9c4',
  /**
   * BalancingBeige-500 '#b18754' 
   */
  balancingBeige500: '#b18754',
  /**
   * BalancingBeige-600 '#936848' 
   */
  balancingBeige600: '#936848',
  /**
   * BalancingBeige-700 '#7b573d' 
   */
  balancingBeige700: '#7b573d',
  /**
   * ElectricYellow-100 '#fcfdc4' 
   */
  electricYellow100: '#fcfdc4',
  /**
   * ElectricYellow-200 '#fcfb8c' 
   */
  electricYellow200: '#fcfb8c',
  /**
   * ElectricYellow-300 '#fbf35a' 
   */
  electricYellow300: '#fbf35a',
  /**
   * ElectricYellow-400 '#f7e218' 
   */
  electricYellow400: '#f7e218',
  /**
   * ElectricYellow-700 '#8c6408' 
   */
  electricYellow700: '#8c6408',
  /**
   * DuskOrange-100 '#ffe7e1' 
   */
  duskOrange100: '#ffe7e1',
  /**
   * DuskOrange-200 '#ffd1c7' 
   */
  duskOrange200: '#ffd1c7',
  /**
   * DuskOrange-400 '#ff9178' 
   */
  duskOrange400: '#ff9178',
  /**
   * DuskOrange-500 '#ef5e3e' 
   */
  duskOrange500: '#ef5e3e',
  /**
   * DuskOrange-600 '#cc3e1f' 
   */
  duskOrange600: '#cc3e1f',
  /**
   * DuskOrange-700 '#b33114' 
   */
  duskOrange700: '#b33114',
  /**
   * BroadBlue-100 '#e4ecf5' 
   */
  broadBlue100: '#e4ecf5',
  /**
   * BroadBlue-200 '#d0deed' 
   */
  broadBlue200: '#d0deed',
  /**
   * BroadBlue-400 '#89acd1' 
   */
  broadBlue400: '#89acd1',
  /**
   * BroadBlue-500 '#6a90c3' 
   */
  broadBlue500: '#6a90c3',
  /**
   * BroadBlue-700 '#4769a5' 
   */
  broadBlue700: '#4769a5',
  /**
   * BroadBlue-900 '#23375b' 
   */
  broadBlue900: '#23375b',
  /**
   * LavenderPurple-100 '#f9ebfc' 
   */
  lavenderPurple100: '#f9ebfc',
  /**
   * LavenderPurple-200 '#f4d6f8' 
   */
  lavenderPurple200: '#f4d6f8',
  /**
   * LavenderPurple-300 '#eeb6f2' 
   */
  lavenderPurple300: '#eeb6f2',
  /**
   * LavenderPurple-500 '#bc76c1' 
   */
  lavenderPurple500: '#bc76c1',
  /**
   * LavenderPurple-600 '#a054a1' 
   */
  lavenderPurple600: '#a054a1',
  /**
   * LavenderPurple-700 '#854586' 
   */
  lavenderPurple700: '#854586',
  /**
   * PoweringGreen-500 '#18d270' 
   */
  poweringGreen500: '#18d270',
  /**
   * IvyGreen-100 '#d6f5e2' 
   */
  ivyGreen100: '#d6f5e2',
  /**
   * IvyGreen-200 '#b0eac9' 
   */
  ivyGreen200: '#b0eac9',
  /**
   * IvyGreen-400 '#47c088' 
   */
  ivyGreen400: '#47c088',
  /**
   * IvyGreen-500 '#25a26c' 
   */
  ivyGreen500: '#25a26c',
  /**
   * IvyGreen-600 '#188156' 
   */
  ivyGreen600: '#188156',
  /**
   * IvyGreen-900 '#0f4632' 
   */
  ivyGreen900: '#0f4632',
  /**
   * FullBlack '#000000' 
   */
  fullBlack: '#000000',
  /**
   * ProfessionalGrey '#111111' 
   */
  professionalGrey: '#111111',
  /**
   * RaisinGrey '#222222' 
   */
  raisinGrey: '#222222',
  /**
   * MineShaftGrey '#292929' 
   */
  mineShaftGrey: '#292929',
  /**
   * InkGrey '#333333' 
   */
  inkGrey: '#333333',
  /**
   * EmperorGrey '#555555' 
   */
  emperorGrey: '#555555',
  /**
   * SonicGrey '#757575' 
   */
  sonicGrey: '#757575',
  /**
   * SilverGrey '#999999' 
   */
  silverGrey: '#999999',
  /**
   * FogGrey '#c9c9c9' 
   */
  fogGrey: '#c9c9c9',
  /**
   * CloudGrey '#f2f2f2' 
   */
  cloudGrey: '#f2f2f2',
  /**
   * LightGrey '#f7f7f7' 
   */
  lightGrey: '#f7f7f7',
  /**
   * SnowWhite '#ffffff' 
   */
  snowWhite: '#ffffff'
};

export { colors };
